import React from 'react';
import DatePicker from "react-datepicker";
import Text from '../../components/text/Text';

interface PaymentCardProps {
	title: string;
	description: string;
	additionalInfo?: string;
	amount: string;
	dateLabel: string;
	selectedDate: Date | null;
	onDateChange: (date: Date | null) => void;
	openDatePicker: () => void;
	openModal: () => void;
	datePickerRef: React.RefObject<any>;
	maxDate: Date;
}

const PaymentCard: React.FC<PaymentCardProps> = ({
	title,
	description,
	additionalInfo,
	amount,
	dateLabel,
	selectedDate,
	onDateChange,
	openDatePicker,
	openModal,
	datePickerRef,
	maxDate
}) => {
	return (
		<div className="uninvoiced-card">
			<h3 className='uninvoiced-title'>{title}</h3>
			<p style={{ fontWeight: 400, fontSize: 14, color: '#656565', fontFamily: 'Nunito' }}>
				{description}
			</p>
			{additionalInfo && (
				<>
					<br />
					<p style={{ fontWeight: 400, fontSize: 14, color: '#656565', fontFamily: 'Nunito' }}>
						{additionalInfo}
					</p>
				</>
			)}
			<div style={{ display: 'flex', marginTop: 30 }}>
				<Text
					label="Consumos por facturar:"
					fontSize={14}
					fontWeight={400}
					color={'#656565'}
					marginRight={15}
				/>
				<Text
					label={amount}
					fontSize={14}
					fontWeight={700}
					color={'#656565'}
				/>
			</div>
			<div style={{ display: 'flex', marginTop: 20 }}>
				<Text
					label="Consumos hasta día:"
					fontSize={14}
					fontWeight={400}
					color={'#656565'}
					marginRight={30}
				/>
				<Text label={dateLabel} fontSize={14} fontWeight={400} color={'#656565'} />
			</div>
			<div style={{ display: 'flex', marginTop: 20 }}>
				<div style={{ display: 'flex', justifyContent: 'center' }}>
					<div style={{ display: 'block' }}>
						<button onClick={openDatePicker} className='uninvoiced-btnFecha'>
							<Text label="Cambiar Fecha" fontWeight={600} color="#ffff" />
						</button>
						<DatePicker
							selected={selectedDate}
							onChange={(date) => {
								if (date) {
									date.setHours(23, 59, 0, 0);
									onDateChange(date);
								}
							}}
							locale="es"
							ref={datePickerRef}
							maxDate={maxDate}
							customInput={<div style={{ display: 'none' }} />}
						/>
					</div>
					<button onClick={openModal} className='uninvoiced-btnSolicitar' disabled={parseFloat(amount) === 0}>
						<Text label="Solicitar" fontWeight={600} color="#ffff" />
					</button>
				</div>
			</div>
		</div>
	);
};

export default PaymentCard;
